import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('fieldsGrid');

    return {
        LAST_ACTIVITY: t('lastActivity'),
        LAST_EDITED: t('lastEdited'),
        LOADING: t('loading'),
        NAME: t('name'),
        NO_FIELDS: t('noFields'),
        NO_MORE_FIELDS: t('noMoreFields')
    };
};

export default useTranslation;
